"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.regexp.to-string.js");

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _vuex = require("vuex");

var _index = require("@/model/exchange/index");

var _order = require("@/model/contractExchange/order");

var _settings = require("@/model/settings");

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var _message = require("@/components/dialog/message");

var _SocketDispatcher = _interopRequireDefault(require("@/assets/js/SocketDispatcher"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  components: {
    InputNumber: _InputNumber.default
  },
  mixins: [_commonMixin.default],
  props: {
    assetsInfoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    assetsInfo: {
      type: Object,
      default: function _default() {
        return {
          remain: {
            all_u_valuation: {
              usdt: "--"
            },
            list: []
          }
        };
      }
    },
    swap_symbol_id: {
      type: [String, Number],
      default: function _default() {
        1010;
      }
    },
    from_symbol: {
      type: [String, Number]
    },
    to_symbol: {
      type: [String, Number]
    },
    from_item_id: {
      type: [String, Number]
    },
    to_item_id: {
      type: [String, Number]
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language",
    userInfo: "user/userInfo"
  })), {}, {
    // 现有U资产
    assetsInfoShow: function assetsInfoShow() {
      var _this = this;

      var tempObj = "0";

      if (JSON.stringify(this.assetsInfo) != "{}" && this.assetsInfo.remain.list.length > 0) {
        this.assetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else if (JSON.stringify(this.apiAssetsInfo) != "{}" && this.apiAssetsInfo.remain.list.length > 0) {
        this.apiAssetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = "0";
      }

      return tempObj;
    },
    // 现有币资产
    assetsInfoShowSell: function assetsInfoShowSell() {
      var _this2 = this;

      var tempObj = "0";

      if (JSON.stringify(this.assetsInfo) != "{}" && this.assetsInfo.remain.list.length > 0) {
        this.assetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this2.from_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = "0";
      }

      return tempObj;
    },
    // 市场现在交易价格
    marketInfoShow: function marketInfoShow() {
      var _this3 = this;

      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this3.swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    }
  }),
  watch: {
    swap_symbol_id: function swap_symbol_id() {
      var _this4 = this;

      if (this.swap_symbol_id == "") {
        return;
      }

      var tempMultipleNum = JSON.parse(localStorage.getItem("contract-multiple-num"));

      for (var key in tempMultipleNum) {
        if (key == this.swap_symbol_id) {
          this.multipleNumBtn = true;
          this.multipleNum = Number(tempMultipleNum[key]);
          setTimeout(function () {
            _this4.multipleNumBtn = false;
          }, 1000);
        }
      }

      if (this.multipleNumBtn == false) {
        this.multipleNum = 20;
      }

      this.buySliderValue = 0;
      this.buyNum = "";
      this.buyPrice = "";
      this.buyPriceSelf = "";
      this.buyAmountSelf = "";
      this.buyAmount = "";
      this.sellNumSelf = "";
      this.tradingVolume = "";
      this.tradingVolumeSelf = "";
      this.sellSliderValue = 0;
      this.sellPrice = "";
      this.sellNum = "";

      if (this.btn) {
        this.number_precision = this.coinInfoMap[this.swap_symbol_id].number_precision;
        this.open_position_rate = this.coinInfoMap[this.swap_symbol_id].open_position_rate;
        this.price_precision = this.coinInfoMap[this.swap_symbol_id].price_precision;
      }
    }
  },
  data: function data() {
    return {
      coinInfoMap: {},
      multipleNumBtn: false,
      currChainValue: "1",
      buySliderValue: 0,
      multipleNum: 20,
      sellSliderValue: 0,
      marketPrice: "",
      buyPrice: "",
      buyPriceSelf: "",
      sellNumSelf: "",
      sellPrice: "",
      buyNum: "",
      buyAmount: "",
      //
      buyAmountSelf: "",
      //现价买入金额 U
      sellNum: "",
      buyTriggerPrice: "",
      sellTriggerPrice: "",
      number_precision: "",
      open_position_rate: "",
      price_precision: "",
      tradingVolume: "",
      // 买入交易量
      tradingVolumeSelf: "",
      // 限价买入交易数量
      transactionAmount: "",
      // 买入交易额
      sellTransactionAmount: "",
      // 卖出交易额
      sellTransactionAmountSelf: "",
      // 限价卖出交易额
      // from_item_id: "",
      // to_item_id: "",
      marks: {
        25: "25%",
        50: "50%",
        75: "75%"
      },
      apiAssetsInfo: {},
      coinInfoList: [],
      tabsOptions: [{
        label: "市价",
        value: 1
      }, {
        label: "限价",
        value: 2
      } // {
      //   label: "止盈止损",
      // },
      ],
      inputControl: false,
      btn: false,
      buyBtnLoading: false,
      sellBtnLoading: false
    };
  },
  created: function created() {
    var _this5 = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this5.getAssets();

            case 2:
              _context.next = 4;
              return _this5.getStaticTableInfo(49);

            case 4:
              _SocketDispatcher.default.addEventListener("onPriceClick", _this5.onPriceClick, _this5);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {//杠杆倍数变化 买入卖出数量变化
    // const that = this;
    // window.addEventListener("setItem", function() {
    //   let tempMultipleNum = JSON.parse(
    //     localStorage.getItem("contract-multiple-num")
    //   );
    //   for (const key in tempMultipleNum) {
    //     if (key == this.swap_symbol_id) {
    //       that.multipleNum = Number(tempMultipleNum[key]);
    //     }
    //   }
    //   if (tempMultipleNum) {
    //     that.onBuyChangeV2("2");
    //     that.onSellNumChangeMarket();
    //     that.onBuyAmountChange(that.buyAmount);
    //     that.onSellNumChange();
    //   }
    // });
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    getAssets: function getAssets() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this6.userInfo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                params = {
                  type: "all"
                };
                _context2.next = 5;
                return (0, _index.apiGetAssets)(params);

              case 5:
                _yield$apiGetAssets = _context2.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  _this6.apiAssetsInfo = data;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onMultipleNumClick: function onMultipleNumClick() {
      this.$emit("onMultipleNumClick", this.multipleNum);
    },
    onPriceClick: function onPriceClick(row) {
      if (this.currChainValue == "2") {
        this.buyPriceSelf = row[0];
        this.onBuyChangeV2("2");
        this.sellPrice = row[0];
        this.onSellNumChange();
      }
    },
    setMultipleNum: function setMultipleNum(value) {
      this.multipleNum = value;
      this.onBuyChangeV2("2");
      this.onSellNumChangeMarket();
      this.onBuyAmountChange(this.buyAmount);
      this.onSellNumChange();
    },
    // 买入滑块变化
    onBuySliderChange: function onBuySliderChange(value) {
      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));

      if (this.currChainValue == "1") {
        if (value && !this.inputControl) {
          // 买入交易额
          this.buyAmount = (value / 100 * this.assetsInfoShow).toFixed(this.price_precision);
          var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
          var tempMultipleNum = new _bignumber.default(this.multipleNum);
          var tempMarketPrice = new _bignumber.default(this.marketPrice); // 开仓手续费 = 保证金 × 杠杆倍数 × 开仓手续费率 open_position_rate

          var tempOpenRate = new _bignumber.default(value / 100);
          var tempOpenPositionRate = new _bignumber.default(this.open_position_rate / 10000); // 买入币种数量

          var tempVolume = new _bignumber.default(value / 100).times(tempAssetsInfoShow).times(tempMultipleNum).minus(new _bignumber.default(value / 100).times(tempAssetsInfoShow).times(tempMultipleNum).times(tempOpenPositionRate)).div(tempMarketPrice).toString();

          if (this.number_precision > 0) {
            this.tradingVolume = tempVolume.substring(0, tempVolume.indexOf(".") + this.number_precision + 1 // +1 保留小数点位数
            );
          } else {
            this.tradingVolume = tempVolume.substring(0, tempVolume.indexOf("."));
          }
        } else if (value == 0 && !this.inputControl) {
          this.buyAmount = "";
          this.tradingVolume = "";
        }
      } else if (this.currChainValue == "2") {
        // buyPriceSelf  限价买入价3 buyAmountSelf 现价买入金额4   tradingVolumeSelf// 现价买入数量6
        if (this.buyPriceSelf != "" && this.buyPriceSelf != 0 && !this.inputControl) {
          var tempPrice = new _bignumber.default(this.buyPriceSelf); // 自定义买入价格

          var _tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow); // 资产


          var _tempMultipleNum = new _bignumber.default(this.multipleNum);

          var _tempOpenPositionRate = new _bignumber.default(this.open_position_rate / 10000);

          this.buyAmountSelf = (value / 100 * this.assetsInfoShow).toFixed(this.price_precision);
          var tempVolumeSelf = new _bignumber.default(value / 100).times(_tempAssetsInfoShow).times(_tempMultipleNum).minus(new _bignumber.default(value / 100).times(_tempAssetsInfoShow).times(_tempMultipleNum).times(_tempOpenPositionRate)).div(tempPrice).toString();

          if (this.number_precision > 0) {
            this.tradingVolumeSelf = tempVolumeSelf.substring(0, tempVolumeSelf.indexOf(".") + this.number_precision + 1); // +1 保留小数点位数
          } else {
            this.tradingVolumeSelf = tempVolumeSelf.substring(0, tempVolumeSelf.indexOf("."));
          }
        }
      }
    },
    // 卖出滑块变化
    onSellSliderChange: function onSellSliderChange(value) {
      // sellNum  卖出金额9  sellTransactionAmount  卖出数量10
      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));

      if (this.currChainValue == "1") {
        var tempMarketPrice = new _bignumber.default(this.marketPrice);
        var tempMultipleNum = new _bignumber.default(this.multipleNum);
        var tempOpenPositionRate = new _bignumber.default(this.open_position_rate / 10000);

        if (value && !this.inputControl) {
          this.sellNum = (value * 0.01 * this.assetsInfoShow).toFixed(this.price_precision);
          var tempNumber = new _bignumber.default(this.sellNum);
          var tempAmount = tempNumber.times(tempMultipleNum).minus(tempNumber.times(tempMultipleNum).times(tempOpenPositionRate));
          var tempSellAmount = tempAmount.div(tempMarketPrice).toString();

          if (this.number_precision > 0) {
            this.sellTransactionAmount = tempSellAmount.substring(0, tempSellAmount.indexOf(".") + this.number_precision + 1);
          } else {
            this.sellTransactionAmount = tempSellAmount.substring(0, tempSellAmount.indexOf("."));
          }
        } else if (value == 0 && !this.inputControl) {
          this.sellNum = "";
          this.sellTransactionAmount = "";
        }
      } else if (this.currChainValue == "2") {
        //  sellPrice 卖出价格8 sellNumSelf 卖出金额12  sellTransactionAmountSelf  卖出数量11
        if (this.sellPrice != "" && this.sellPrice != 0) {
          if (value && !this.inputControl) {
            var tempSellPrice = new _bignumber.default(this.sellPrice);
            this.sellNumSelf = value * 0.01 * this.assetsInfoShow;

            var _tempMultipleNum2 = new _bignumber.default(this.multipleNum);

            var _tempNumber = new _bignumber.default(this.sellNumSelf);

            var _tempOpenPositionRate2 = new _bignumber.default(this.open_position_rate / 10000);

            var _tempAmount = _tempNumber.times(_tempMultipleNum2).minus(_tempNumber.times(_tempMultipleNum2).times(_tempOpenPositionRate2));

            var sellAmountSelf = _tempAmount.div(tempSellPrice).toString();

            if (this.number_precision > 0) {
              this.sellTransactionAmountSelf = sellAmountSelf.substring(0, sellAmountSelf.indexOf(".") + this.number_precision + 1);
            } else {
              this.sellTransactionAmountSelf = sellAmountSelf.substring(0, sellAmountSelf.indexOf("."));
            }
          } else if (value == 0 && !this.inputControl) {
            this.sellNumSelf = "";
            this.sellTransactionAmountSelf = "";
          }
        }
      }
    },
    // 市价交易额变化
    onBuyAmountChange: function onBuyAmountChange(val) {
      var _this7 = this;

      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
      this.inputControl = true;
      var tempInput = new _bignumber.default(val);
      var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
      var tempVal = tempInput.div(tempAssetsInfoShow).toNumber();
      var tempVal2 = JSON.parse(JSON.stringify(tempVal)) * 100;

      if (tempVal2 > 100) {
        tempVal2 = 100;
      } // 买入滑块


      this.buySliderValue = Number(tempVal2.toFixed(0)); // 买入 预开仓数量

      var tempValV2 = "0";
      var bigMarketInfoShow = new _bignumber.default(JSON.parse(JSON.stringify(this.marketPrice)));

      if (this.buyAmount == "0") {
        tempValV2 = "0";
      } else if (this.buyAmount != "" && this.marketInfoShow.last) {
        var bigBuyAmount = new _bignumber.default(this.buyAmount);
        var tempMultipleNum = new _bignumber.default(this.multipleNum);
        var tempOpenPositionRate = new _bignumber.default(this.open_position_rate / 10000);
        tempValV2 = bigBuyAmount.times(tempMultipleNum).minus(bigBuyAmount.times(tempMultipleNum).times(tempOpenPositionRate));
        var tempVolume = tempValV2.div(bigMarketInfoShow).toString();

        if (this.number_precision > 0) {
          this.tradingVolume = tempVolume.substring(0, tempVolume.indexOf(".") + this.number_precision + 1 // +1 保留小数点位数
          );
        } else {
          this.tradingVolume = tempVolume.substring(0, tempVolume.indexOf("."));
        }
      } else {
        tempValV2 = "0";
      }

      setTimeout(function () {
        _this7.inputControl = false;
      }, 1000);
    },
    // 市价买入数量变化
    onBuyTotalChange: function onBuyTotalChange(val) {
      var _this8 = this;

      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
      this.inputControl = true; // 买入 预计开仓数量

      var tempValV2 = "0";

      if (this.tradingVolume == "0") {
        tempValV2 = "0";
      } else if (this.tradingVolume != "" && this.marketInfoShow.last) {
        var bigBuyAmount = new _bignumber.default(this.tradingVolume);
        var bigMarketInfoShow = new _bignumber.default(JSON.parse(JSON.stringify(this.marketPrice)));
        tempValV2 = bigBuyAmount.times(bigMarketInfoShow).toNumber();
      } else {
        tempValV2 = "0";
      }

      this.buyAmount = (tempValV2 / this.multipleNum).toFixed(this.price_precision);
      var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
      var tempBuyAmount = new _bignumber.default(this.buyAmount);
      var tempVal = tempBuyAmount.div(tempAssetsInfoShow).toNumber();
      var tempVal2 = JSON.parse(JSON.stringify(tempVal)) * 100;

      if (tempVal2 > 100) {
        tempVal2 = 100;
      }

      this.buySliderValue = Number(tempVal2.toFixed(0)); // 买入滑块

      setTimeout(function () {
        _this8.inputControl = false;
      }, 1000);
    },
    onBuyChangeV3: function onBuyChangeV3() {
      var _this9 = this;

      // buyPriceSelf  限价买入价3 buyAmountSelf 现价买入金额4   tradingVolumeSelf// 现价买入数量6
      if (this.tradingVolumeSelf == "" || Number(this.tradingVolumeSelf) == 0) {
        this.inputControl = true;
        this.buySliderValue = 0;
        this.buyAmountSelf = "";
        this.tradingVolumeSelf = "";
        return;
      }

      this.inputControl = true;

      if (this.buyPriceSelf != "") {
        var tempPrice = new _bignumber.default(this.buyPriceSelf); // 自定义买入价格

        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow); // 资产

        var tempTradingVolumeSelf = new _bignumber.default(this.tradingVolumeSelf); // 现价买入数量6

        var tempMultipleNum = new _bignumber.default(this.multipleNum);
        var tempValue = tempPrice.times(tempTradingVolumeSelf).div(tempMultipleNum).div(tempAssetsInfoShow).toNumber() * 100;
        this.buySliderValue = Number(tempValue.toFixed(2));
        this.buyAmountSelf = tempPrice.times(tempTradingVolumeSelf).div(tempMultipleNum).toNumber().toFixed(this.price_precision);
      } else {
        this.buySliderValue = 0;
        this.buyAmountSelf = "";
      }

      setTimeout(function () {
        _this9.inputControl = false;
      }, 1000);
    },
    // 限价买入量变化
    onBuyChangeV2: function onBuyChangeV2(type) {
      var _this10 = this;

      // buyPriceSelf  限价买入价3 buyAmountSelf 现价买入金额4   tradingVolumeSelf// 现价买入数量6
      if (this.buyPriceSelf == "" || this.buyPriceSelf == 0 || this.buyAmountSelf == "" || this.buyAmountSelf == 0) {
        this.tradingVolumeSelf = "";
        return;
      }

      if (this.userInfo) {
        this.inputControl = true;
        var tempPrice = new _bignumber.default(this.buyPriceSelf); // 自定义买入价格

        var tempAmount = new _bignumber.default(this.buyAmountSelf); // 自定义买入数量

        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
        var tempMultipleNum = new _bignumber.default(this.multipleNum);
        var tempValue = tempAmount.div(tempAssetsInfoShow).toNumber() * 100;
        this.buySliderValue = Number(tempValue.toFixed(2));
        var tempOpenPositionRate = new _bignumber.default(this.open_position_rate / 10000);

        if (this.buyPriceSelf != "" && this.buyAmountSelf != "") {
          var tempVolumeSelf = tempAmount.times(tempMultipleNum).minus(tempAmount.times(tempMultipleNum).times(tempOpenPositionRate)).div(tempPrice).toString();

          if (this.number_precision > 0) {
            this.tradingVolumeSelf = tempVolumeSelf.substring(0, tempVolumeSelf.indexOf(".") + this.number_precision + 1); // +1 保留小数点位数
          } else {
            this.tradingVolumeSelf = tempVolumeSelf.substring(0, tempVolumeSelf.indexOf("."));
          }
        }
      }

      setTimeout(function () {
        _this10.inputControl = false;
      }, 1000);
    },
    // 9
    onSellNumChangeMarket: function onSellNumChangeMarket() {
      var _this11 = this;

      // sellNum  卖出金额9  sellTransactionAmount  卖出数量10
      if (this.userInfo) {
        if (this.sellNum == "") {
          this.sellSliderValue = 0;
          this.sellTransactionAmount = "";
        }

        this.inputControl = true;
        this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
        var tempMarketPrice = new _bignumber.default(this.marketPrice);
        var tempSellNum = new _bignumber.default(this.sellNum);
        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
        var tempMultipleNum = new _bignumber.default(this.multipleNum);
        var tempOpenPositionRate = new _bignumber.default(this.open_position_rate / 10000);
        var tempAmount = tempSellNum.times(tempMultipleNum).minus(tempSellNum.times(tempMultipleNum).times(tempOpenPositionRate));
        var tempSellAmount = tempAmount.div(tempMarketPrice).toString();

        if (this.number_precision > 0) {
          this.sellTransactionAmount = tempSellAmount.substring(0, tempSellAmount.indexOf(".") + this.number_precision + 1);
        } else {
          this.sellTransactionAmount = tempSellAmount.substring(0, tempSellAmount.indexOf("."));
        }

        var tempValue = tempSellNum.div(tempAssetsInfoShow).toNumber() * 100;
        this.sellSliderValue = Number(tempValue.toFixed(0));
      }

      setTimeout(function () {
        _this11.inputControl = false;
      }, 1000);
    },
    // 8 12
    onSellNumChange: function onSellNumChange() {
      var _this12 = this;

      //  sellPrice 卖出价格8 sellNumSelf 卖出金额12  sellTransactionAmountSelf  卖出数量11
      if (this.sellPrice == "" || this.sellPrice == 0 || this.sellNumSelf == "" || this.sellNumSelf == 0) {
        this.sellTransactionAmountSelf = "";
        return;
      }

      if (this.userInfo) {
        this.inputControl = true;
        this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
        var tempSellPrice = new _bignumber.default(this.sellPrice);
        var tempSellNum = new _bignumber.default(this.sellNumSelf);
        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
        var tempMultipleNum = new _bignumber.default(this.multipleNum);
        var tempOpenPositionRate = new _bignumber.default(this.open_position_rate / 10000);
        var tempAmount = tempSellNum.times(tempMultipleNum).minus(tempSellNum.times(tempMultipleNum).times(tempOpenPositionRate));
        var sellAmountSelf = tempAmount.div(tempSellPrice).toString();

        if (this.number_precision > 0) {
          this.sellTransactionAmountSelf = sellAmountSelf.substring(0, sellAmountSelf.indexOf(".") + this.number_precision + 1);
        } else {
          this.sellTransactionAmountSelf = sellAmountSelf.substring(0, sellAmountSelf.indexOf("."));
        }

        var tempValue = tempSellNum.div(tempAssetsInfoShow).toNumber() * 100;
        this.sellSliderValue = Number(tempValue.toFixed(0));
      }

      setTimeout(function () {
        _this12.inputControl = false;
      }, 1000);
    },
    // 卖出金额变化  卖出数量11
    onSellNumChangeSelf: function onSellNumChangeSelf(val) {
      var _this13 = this;

      //  sellPrice 卖出价格8 sellNumSelf 卖出金额12  sellTransactionAmountSelf  卖出数量11
      if (this.sellPrice == "") {
        this.sellNumSelf = "";
        return;
      }

      if (this.userInfo) {
        this.inputControl = true;
        this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
        var tempPrice = new _bignumber.default(this.sellPrice);
        var tempInput = new _bignumber.default(val);
        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
        var tempMultipleNum = new _bignumber.default(this.multipleNum);

        if (val != "") {
          this.sellNumSelf = tempInput.times(tempPrice).times(tempMultipleNum).toFixed(this.price_precision);
          var tempSellNumSelf = new _bignumber.default(this.sellNumSelf);
          this.sellSliderValue = tempSellNumSelf.div(tempAssetsInfoShow).toNumber() * 100;
        } else {
          this.sellNumSelf = "";
          this.sellSliderValue = 0;
        }

        setTimeout(function () {
          _this13.inputControl = false;
        }, 1000);
      }

      setTimeout(function () {
        _this13.inputControl = false;
      }, 1000);
    },
    // 卖出金额变化 10
    onSellTotalChange: function onSellTotalChange(val) {
      var _this14 = this;

      // sellNum  卖出金额9  sellTransactionAmount  卖出数量10
      if (this.userInfo) {
        this.inputControl = true;
        this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
        var tempMarketPrice = new _bignumber.default(this.marketPrice);
        var tempInput = new _bignumber.default(val);
        var tempMultipleNum = new _bignumber.default(this.multipleNum);
        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);

        if (val != "") {
          this.sellNum = tempInput.times(tempMarketPrice).div(tempMultipleNum).toFixed(this.price_precision);
          var tempSellNum = new _bignumber.default(this.sellNum);
          this.sellSliderValue = tempSellNum.div(tempAssetsInfoShow).toNumber() * 100;
        } else {
          this.sellNum = "";
          this.sellSliderValue = 0;
        }

        setTimeout(function () {
          _this14.inputControl = false;
        }, 1000);
      }
    },
    formatTooltip: function formatTooltip(val) {
      return val + "%";
    },
    onTrade: function onTrade(type) {
      var _this15 = this;

      // 1买入 2卖出
      if (type == 1) {
        if (this.currChainValue == "1") {
          if (this.buyAmount == "" || Number(this.buyAmount == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入交易额"),
              type: "error"
            });
            return;
          }

          if (Number(this.buyAmount) > Number(this.assetsInfoShow)) {
            (0, _message.showMessage)({
              message: this.translateTitle("可用余额不足"),
              type: "error"
            });
            return;
          }

          this.buyBtnLoading = true;
          var params = {
            leverage: this.multipleNum,
            symbol_id: this.swap_symbol_id,
            open_side: "1",
            //开仓方向 1 买涨 2 买跌
            bail_number: this.buyAmount,
            // 购买数量
            market_price: this.marketInfoShow.last // 购买数量

          };
          (0, _order.apiOpenPosition)(params).then(function (res) {
            if (res.status == 200) {
              (0, _message.showMessage)({
                message: _this15.translateTitle("下单成功"),
                type: "success"
              });
              _this15.buyBtnLoading = false;

              _this15.reSetData();

              _this15.$emit("on-trade-success", "1");
            } else {
              _this15.buyBtnLoading = false;
            }
          });
        } else if (this.currChainValue == "2") {
          if (this.buyPriceSelf == "" || Number(this.buyPriceSelf == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入买入价格"),
              type: "error"
            });
            return;
          }

          if (this.buyAmountSelf == "" || Number(this.buyAmountSelf == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入买入量"),
              type: "error"
            });
            return;
          }

          if (Number(this.buyAmountSelf) > Number(this.assetsInfoShow)) {
            (0, _message.showMessage)({
              message: this.translateTitle("可用余额不足"),
              type: "error"
            });
            return;
          }

          this.buyBtnLoading = true;
          var _params = {
            leverage: this.multipleNum,
            symbol_id: this.swap_symbol_id,
            open_side: "1",
            //开仓方向 1 买涨 2 买跌
            bail_number: this.buyAmountSelf,
            // 购买数量
            trigger_price: this.buyPriceSelf
          };
          (0, _order.apiPlanOrder)(_params).then(function (res) {
            if (res.status == 200) {
              (0, _message.showMessage)({
                message: _this15.translateTitle("下单成功"),
                type: "success"
              });
              _this15.buyBtnLoading = false;

              _this15.reSetData();

              _this15.$emit("on-trade-success", "2");
            } else {
              _this15.buyBtnLoading = false;
            }
          });
        }
      } else {
        // 2 卖出
        if (this.currChainValue == "1") {
          if (this.sellNum == "" || Number(this.sellNum == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入卖出量"),
              type: "error"
            });
            return;
          }

          if (Number(this.sellNum) > Number(this.assetsInfoShow)) {
            (0, _message.showMessage)({
              message: this.translateTitle("可用余额不足"),
              type: "error"
            });
            return;
          }

          this.sellBtnLoading = true;
          var _params2 = {
            leverage: this.multipleNum,
            symbol_id: this.swap_symbol_id,
            open_side: "2",
            //开仓方向 1 买涨 2 买跌
            bail_number: this.sellNum,
            // 购买数量
            market_price: this.marketInfoShow.last // 购买数量

          };
          (0, _order.apiOpenPosition)(_params2).then(function (res) {
            if (res.status == 200) {
              (0, _message.showMessage)({
                message: _this15.translateTitle("下单成功"),
                type: "success"
              });
              _this15.sellBtnLoading = false;

              _this15.reSetData();

              _this15.$emit("on-trade-success", "1");
            } else {
              _this15.sellBtnLoading = false;
            }
          });
        } else if (this.currChainValue == "2") {
          if (this.sellPrice == "" || Number(this.sellPrice == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入卖出价"),
              type: "error"
            });
            return;
          }

          if (this.sellNumSelf == "" || Number(this.sellNumSelf == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入卖出量"),
              type: "error"
            });
            return;
          }

          if (Number(this.sellNumSelf) > Number(this.assetsInfoShow)) {
            (0, _message.showMessage)({
              message: this.translateTitle("可用余额不足"),
              type: "error"
            });
            return;
          }

          this.sellBtnLoading = true;
          var _params3 = {
            leverage: this.multipleNum,
            symbol_id: this.swap_symbol_id,
            open_side: "2",
            //开仓方向 1 买涨 2 买跌
            bail_number: this.sellNumSelf,
            // 购买数量
            trigger_price: this.sellPrice
          };
          (0, _order.apiPlanOrder)(_params3).then(function (res) {
            if (res.status == 200) {
              (0, _message.showMessage)({
                message: _this15.translateTitle("下单成功"),
                type: "success"
              });
              _this15.sellBtnLoading = false;

              _this15.reSetData();

              _this15.$emit("on-trade-success", "2");
            } else {
              _this15.sellBtnLoading = false;
            }
          });
        }
      }
    },
    goLogin: function goLogin(type) {
      if (type == 1) {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
      } else {
        this.$router.push(this.routeSplicing(this.language, "register"));
      }
    },
    onChainChange: function onChainChange(value) {
      var _this16 = this;

      this.inputControl = true;
      this.currChainValue = value;
      this.sellSliderValue = 0;
      this.buySliderValue = 0;
      this.buyNum = "";
      this.buyPriceSelf = "";
      this.buyPrice = "";
      this.buyAmount = "";
      this.sellTransactionAmountSelf = "";
      this.sellNumSelf = "";
      this.sellPrice = "";
      this.sellNum = "";
      this.tradingVolume = "";
      this.tradingVolumeSelf = "";
      this.transactionAmount = "";
      this.sellTransactionAmount = "";
      this.buyAmountSelf = "";
      setTimeout(function () {
        _this16.inputControl = false;
      }, 300);
    },
    reSetData: function reSetData() {
      var _this17 = this;

      this.inputControl = true;
      this.sellSliderValue = 0;
      this.buySliderValue = 0;
      this.sellSliderValue = 0;
      this.buySliderValue = 0;
      this.buyNum = "";
      this.sellTransactionAmountSelf = "";
      this.buyPriceSelf = "";
      this.buyPrice = "";
      this.buyAmount = "";
      this.sellNumSelf = "";
      this.sellPrice = "";
      this.sellNum = "";
      this.tradingVolume = "";
      this.tradingVolumeSelf = "";
      this.transactionAmount = "";
      this.sellTransactionAmount = "";
      this.buyAmountSelf = "";
      setTimeout(function () {
        _this17.inputControl = false;
      }, 300);
    },
    getStaticTableInfo: function getStaticTableInfo(sv_id) {
      var _this18 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(sv_id);

              case 2:
                _yield$apiGetStaticTa = _context3.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this18.coinInfoMap = JSON.parse(JSON.stringify(data));
                  _this18.btn = true;

                  if (_this18.swap_symbol_id) {
                    _this18.number_precision = _this18.coinInfoMap[_this18.swap_symbol_id].number_precision;
                    _this18.open_position_rate = _this18.coinInfoMap[_this18.swap_symbol_id].open_position_rate;
                    _this18.price_precision = _this18.coinInfoMap[_this18.swap_symbol_id].price_precision;
                  } // this.coinInfoList = JSON.parse(JSON.stringify(data));
                  // for (const key in this.coinInfoList) {
                  //   if (this.coinInfoList[key].swap_symbol_id == this.swap_symbol_id) {
                  //     this.from_item_id = this.coinInfoList[key].from_item_id;
                  //     this.to_item_id = this.coinInfoList[key].to_item_id;
                  //   }
                  // }

                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};
exports.default = _default2;